import React, { useMemo } from 'react'
import styled from 'styled-components'
import { IconPurchaseAuthBadge } from 'components/Icons'

export interface ScheduleBottomOverlayProps {
  isShowPurchaseAuthBadge?: boolean
}

const ScheduleBottomOverlay: React.FC<ScheduleBottomOverlayProps> = (props) => {
  const { isShowPurchaseAuthBadge } = props

  const bottomEl = useMemo(() => {
    return isShowPurchaseAuthBadge ? (
      <div className="badge-purchase-auth">
        <IconPurchaseAuthBadge />
      </div>
    ) : null
  }, [isShowPurchaseAuthBadge])

  return <StyledBottom>{bottomEl}</StyledBottom>
}

export default ScheduleBottomOverlay

const StyledBottom = styled.div`
  position: absolute;
  bottom: 8px;
  left: 8px;
  right: 8px;
  align-items: center;
  display: flex;
  z-index: 30;
  .blind_sf {
    position: absolute;
    overflow: hidden;
    clip: rect(0 0 0 0);
    width: 1px;
    height: 1px;
    margin: -1px;
    line-height: normal;
    font-size: medium;
    white-space: nowrap;
  }

  .badge-purchase-auth {
    width: 34px;
    height: 34px;
    background-size: contain;
  }
`
